module.exports = __webpack_public_path__ + "user1/user1-cb629e17495d3f6dfc7fb3d9f85fc6b5.png";